<template>
  <hic-list-page title="病历质控" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="患者姓名、就诊号、医生姓名、科室">
    <template slot="buttons">
      <el-button v-if="permission.emr_qc_setting" type="primary" size="small" icon="el-icon-collection-tag" @click="meta.showTimeRule = true">规则</el-button>
    </template>
    <el-table-column label="操作" align="center" width="150">
      <template slot-scope="{ row }">
        <el-button v-if="permission.emr_qc_edit && selectTabName == 'first'" title="质控" type="primary" plain size="mini" circle icon="el-icon-wind-power" @click="edit(row)" :disabled="!row.qcState || row.qcState == '未提交' || row.qcState == '通过'"></el-button>
        <el-button v-if="selectTabName == 'second'" title="详情" type="info" plain size="mini" circle icon="el-icon-search" class="left-pad" @click="edit(row)"></el-button>
        <el-button v-if="selectTabName == 'first' || selectTabName == 'second'" title="明细" type="info" plain size="mini" circle icon="el-icon-chat-line-square" class="left-pad" @click="view(row)"></el-button>
        <el-button v-if="!row.ifArchived" title="归档" type="warning" plain size="mini" circle icon="el-icon-folder-checked" class="left-pad" @click="archive(row)" :disabled="row.qcState != '通过'"></el-button>
        <el-button v-else title="取消归档" type="danger" plain size="mini" circle icon="el-icon-folder-delete" class="left-pad" @click="archive(row)"></el-button>
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="qcState" width="100" :filters="dictEnum.MrQCState" :filter-multiple="false" column-key="qcState" sortable="custom" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifArchived" type="warning" hit size="mini">已归档</el-tag>
        <el-tag v-else-if="'通过' == row.qcState" type="success" hit size="mini">{{ row.qcState }}</el-tag>
        <el-tag v-else-if="'不通过' == row.qcState" type="danger" hit size="mini">{{ row.qcState }}</el-tag>
        <el-tag v-else-if="'待质控' == row.qcState" type="primary" hit size="mini">{{ row.qcState }}</el-tag>
        <el-tag v-else type="info" hit size="mini" effect="plain">{{ row.qcState }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="患者" prop="patientName" sortable="custom" align="left">
      <template slot-scope="{ row }">
        <b>{{ row.patientName }}</b>
      </template>
    </el-table-column>
    <el-table-column label="就诊号" prop="opNo" width="180" sortable="custom" align="center"> </el-table-column>
    <el-table-column v-if="selectTabName == 'second'" column-key="status" :filters="dictEnum.MrQCStatus" :filter-multiple="false" sortable="custom" label="状态" prop="qcState" align="center"> </el-table-column>
    <el-table-column v-if="permission.emr_qc_all" column-key="deptCode" :filters="dict.Dept" :filter-multiple="false" sortable="custom" label="科室" prop="deptCode" align="center">
      <template slot-scope="{ row }"> {{ row.deptCode | dictText("Dept") }} </template>
    </el-table-column>
    <el-table-column v-else label="科室" prop="deptCode" :filters="dict.Dept" :filter-multiple="false" :filtered-value="[user.deptCode]" column-key="deptCode" sortable="custom" align="center">
      <template slot-scope="{ row }"> {{ row.deptCode | dictText("Dept") }} </template>
    </el-table-column>
    <el-table-column label="医生" prop="doctorName" sortable="custom" align="center"></el-table-column>
    <el-table-column sortable="custom" label="就诊时间" prop="submitTime" align="center" width="200">
      <template slot-scope="{ row }"> {{ row.opTime }} </template>
    </el-table-column>

    <RuleList :visible.sync="meta.showTimeRule"></RuleList>

    <detail :visible.sync="meta.showDetail" :mr-main="mrMain"></detail>
    <editor :visible.sync="meta.showEditor" :mr-main="mrMain" @submited="page" />
  </hic-list-page>
</template>

<script>
  import { mapGetters } from "sw-hic";
  import store from "@/common/store";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.emr_qc_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    beforeRouteLeave(to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      this.meta.showEditor = false;
      this.meta.showDetail = false;
      next();
    },
    components: {
      editor: () => import("./editor"),
      detail: () => import("./detail"),
      RuleList: () => import("./ruleIndex"),
    },
    data() {
      return {
        mrMain: null,
        selectTabName: "first",
        meta: {
          showDetail: false,
          showTimeRule: false,
          loading: false,
          showContentRule: false,
          showEditor: false,
        },
        condition: {
          deptCode: null,
          pageIndexOnView: 1,
          keyword: "",
          pageSize: 20,
          sort: "submitTime",
          asc: false,
        },
        entities: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    created() {
      this.condition.deptCode = this.user.deptCode;
    },
    methods: {
      page() {
        this.meta.loading = true;
        this.$api.MrMain.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      edit(row) {
        this.meta.loading = true;
        this.$api.MrMain.lock(row.id)
          .then((res) => {
            this.mrMain = res;
            this.meta.showEditor = true;
          })
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      view(row) {
        this.mrMain = row;
        this.meta.showDetail = true;
      },
      archive(row) {
        let msg = "归档";
        let method = "archive";
        if (row.ifArchived) {
          msg = "取消归档";
          method = "unarchive";
        }
        this.$confirm(`确定要${msg}！`, msg, {
          type: "warning",
        }).then(() => {
          this.meta.loading = true;
          this.$api.MrMain[method](row.id)
            .then((res) => {
              this.$message.success("归档成功！");
              this.page();
            })
            .catch((err) => {
              this.$message.error(err);
            })
            .finally(() => {
              this.meta.loading = false;
            });
        });
      },
    },
  };
</script>
